// styles
import './styles/graphic.scss';

export default function (props, container, isMobile) {
  const {
    color,
    data,
    fmtYearAbbrev,
    fmtYearFull,
    fmtMonth,
    height,
    initialWidth,
    initialHeight,
    margins,
    path,
    width,
    x,
    xAxis,
    y,
    yAxis,
  } = props;

  const xTicks = isMobile ? 5 : 10;
  const yTicks = isMobile ? 10 : 10;

  const ticksMobi = [
    '1/1/2020',
    '2/1/2020',
    '3/1/2020',
    '4/1/2020',
    '5/1/2020',
    '6/1/2020',
    '7/1/2020',
    '8/1/2020',
    '9/1/2020',
    '10/1/2020',
    '11/1/2020',
    '12/1/2020',
    '1/1/2021',
    '2/1/2021',
  ];

  const dates = {
    // January: 'Jan.',
    February: 'Feb.',
    // March: 'March',
    April: 'April',
    // May: 'May',
    June: 'June',
    // July: 'July',
    August: 'Aug.',
    // September: 'Sept.',
    October: 'Oct.',
    // November: 'Nov.',
    December: 'Dec.',
  };
  //
  const xGrid = xAxis(x)
    // .ticks(xTicks)
    .tickValues(ticksMobi.map(d => new Date(d)))
    .tickFormat((d, i) => {
      // console.log(fmtMonth(d));
      if (fmtMonth(d) === 'February 2020') {
        return 'Feb. \'20';
      } if (fmtMonth(d) === 'February 2021') {
        return 'Feb. \'21';
      }
      return dates[fmtMonth(d).split(' ')[0]];
    },
      // ? (fmtMonth(d).split(' ')[1] === '2021') ? `${dates[fmtMonth(d).split(' ')[0]]} '21` : dates[fmtMonth(d).split(' ')[0]]
      // : (fmtMonth(d).split(' ')[1] === '2021') ? `${dates[fmtMonth(d).split(' ')[0]]} '21` : dates[fmtMonth(d).split(' ')[0]]
    );

  // legend
  container.insert('ul', ':first-child')
    .attr('class', 'key')
    .selectAll('li')
    .data(data)
    .enter()
    .append('li')
    .attr('class', 'key-item')
    .html(d => `<span class='key-block' style='background-color:${color(d.id)};'></span> ${d.id}`);

  // svg
  const svg = container.append('svg')
    .attr('width', initialWidth)
    .attr('height', initialHeight);

  const g = svg.append('g')
    .attr('transform', `translate(${[margins.left, margins.top]})`);

  // x axis
  g.append('g')
    .attr('class', 'grid x')
    .attr('transform', `translate(${[0, height]})`)
    .call(xGrid);

 	// y axis
  const yGrid = g.append('g')
    .attr('class', 'grid y')
    .call(yAxis(y).ticks(yTicks));

  yGrid.selectAll('text')
    .text(d => `${d}%`); // hide first tick's text
  yGrid.selectAll('line').attr('x2', width);

  // lines
  const lines = g.append('g')
    .attr('class', 'lines')
    .selectAll('g')
    .data(data)
    .enter()
    .append('g')
    .attr('class', 'line');

  lines.append('path')
    .attr('stroke', d => color(d.id))
    .attr('d', d => path(d.values));

  // labels
  const label = lines.append('g')
    .attr('class', 'data-label');

  label.append('text')
    .attr('transform', (d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const x0 = x(d0.date) + 5;
      const y0 = y(d0.value) + (d.id === 'Asian' ? 10 : 3);
      return `translate(${[x0, y0]})`;
    })
    .style('fill', d => color(d.id))
    .text((d) => {
      const d0 = d.values.find((val, index, arr) => index === arr.length - 1);
      const { value } = d0;
      return `${value.toFixed(1)}%`;
    });
}
